import { cardTitle } from 'assets/jss/material-dashboard-pro-react.jsx';
import {
  primaryColor,
  dangerColor,
  successColor,
  defaultFont,
  whiteColor,
  darkColor,
} from 'assets/jss/material-dashboard-pro-react.jsx';

const fyndaStyle = (theme) => ({
  [theme.breakpoints.down('sm')]: {
    search: {
      backgroundColor: '#9EA0EE',
      borderRadius: '15px',
      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.25)',
      width: '100%',
      margin: '0px auto',
      marginBottom: '40px',
      marginTop: '-30px',
      padding: '0px 10px 0px 15px',
    },
  },
  [theme.breakpoints.up('md')]: {
    CustomInput: {
      width: '80%',
      margin: '-20px 0px 10px 0px',
      color: 'white',
    },
  },
  searchBody: {
    color: '#FFFFFF !important',
    margin: '-30px 10px -8px 0px',
  },
  disabled: {
    '&:before': {
      borderColor: 'transparent !important',
    },
  },
  underline: {
    '&:hover:not($disabled):before,&:before': {
      borderColor: '#D2D2D2 !important',
      borderWidth: '1px !important',
    },
    '&:after': {
      borderColor: primaryColor,
    },
  },
  underlineError: {
    '&:after': {
      borderColor: dangerColor,
    },
  },
  underlineSuccess: {
    '&:after': {
      borderColor: successColor,
    },
  },
  labelRoot: {
    ...defaultFont,
    color: '#AAAAAA !important',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '1.42857',
    top: '10px',
    '& + $underline': {
      marginTop: '0px',
    },
  },
  labelRootError: {
    color: dangerColor + ' !important',
  },
  labelRootSuccess: {
    color: successColor + ' !important',
  },
  formControl: {
    margin: '0 0 17px 0',
    paddingTop: '27px',
    position: 'relative',
    verticalAlign: 'unset',
    '& svg,& .fab,& .far,& .fal,& .fas,& .material-icons': {
      color: '#FFFFFF',
    },
  },
  whiteUnderline: {
    '&:hover:not($disabled):before,&:before': {
      backgroundColor: '#FFFFFF',
    },
    '&:after': {
      backgroundColor: '#FFFFFF',
    },
  },
  input: {
    color: '#FFFFFF !important',
    '&,&::placeholder': {
      fontSize: '14px',
      fontFamily: '"Monda", "Helvetica", "Arial", sans-serif',
      fontWeight: '400',
      lineHeight: '1.42857',
      opacity: '1',
    },
    '&::placeholder': {
      color: '#FFFFFF !important',
    },
  },
  whiteInput: {
    '&,&::placeholder': {
      color: '#FFFFFF !important',
      opacity: '1',
    },
  },
});
export default fyndaStyle;

// [theme.breakpoints.down("sm")]: {
//   eternal: {
//     position: "fixed",
//     bottom: "75px",
//     width: "60%",
//     border: "transparent",
//     color: "#1C3E59",
//     padding: "12px 0px 15px 0px",
//     zIndex: "99",
//     background: "linear-gradient(90deg, rgba(143,206,159,1) 0%, rgba(241,232,102,1) 100%)",
//     borderRadius: "50px",
//     boxShadow: "0px 0px 15px -5px rgba(0,0,0,0.75)",
//     fontWeight: "600",
//     fontSize: "16px",
//     animation: "MoveUpDown 2s linear infinite"
//   }
// },
